import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_5 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = { class: "d-flex gap-3 align-items-center" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_26 = { class: "small text-muted mt-15" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_30 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_31 = {
  key: 0,
  class: "col-12 mt-25"
}
const _hoisted_32 = { class: "position-relative" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute end-0 z-1 m-10" }, [
  /*#__PURE__*/_createElementVNode("div", {
    "data-bs-toggle": "modal",
    "data-bs-target": `#deleteCover`,
    class: "align-items-center bg-danger-subtle d-inline-flex fs-3 h-50 justify-content-center rounded-circle text-danger w-50 cursor-pointer"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "ph-bold ph-x" })
  ])
], -1 /* HOISTED */)
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_36 = {
  key: 1,
  class: "col-12"
}
const _hoisted_37 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_38 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_39 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_41 = { class: "position-relative" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_44 = { class: "row justify-content-center" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" LANG "),
            (_ctx.update)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.locales.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('feature.contents.lang')), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_country_flag, {
                            country: _ctx.lang,
                            size: "big"
                          }, null, 8 /* PROPS */, ["country"]),
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select shadow-none text-black p-15 pe-50 fs-14 fw-medium w-auto",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lang) = $event)),
                            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLang())),
                            required: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (locale) => {
                              return (_openBlock(), _createElementBlock("option", {
                                value: locale,
                                key: locale
                              }, _toDisplayString(_ctx.$t(`feature.contents.$lang.${locale}`)), 9 /* TEXT, PROPS */, _hoisted_8))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [_vModelSelect, _ctx.lang]
                          ])
                        ]),
                        _createCommentVNode(" ERRORS "),
                        (_ctx.errors?.lang ?? false)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.lang, (error) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: error,
                                  class: "small text-danger lh-1 m-0 mt-1"
                                }, _toDisplayString(error), 1 /* TEXT */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_10,
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('form.name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.category.name![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.name }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.category.name![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.name ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.name, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_15,
            _createCommentVNode(" DESCRIPTION "),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.category.description![_ctx.lang]) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.description }]]),
                  rows: "6"
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.category.description![_ctx.lang]]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.description ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.description, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_20,
            _createCommentVNode(" VISIBILITY "),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('feature.contents.$categories.visibility')) + "* ", 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.allow }]]),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.category.allow) = $event)),
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibility_options, (visibility) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: visibility,
                        value: visibility
                      }, _toDisplayString(_ctx.$t(`feature.contents.$categories.$visibility.${visibility}`)), 9 /* TEXT, PROPS */, _hoisted_24))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 2 /* CLASS */), [
                    [_vModelSelect, _ctx.category.allow]
                  ])
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.allow ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.allow, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_26, "*" + _toDisplayString(_ctx.$t('feature.contents.$categories.visibility_checkbox_message')), 1 /* TEXT */)
              ])
            ]),
            _createCommentVNode(" COVER SELECT "),
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('feature.contents.$categories.imageCover')), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _createElementVNode("input", {
                    class: "form-control fs-15 text-black shadow-none",
                    type: "file",
                    id: "cover-picker",
                    onChange: _cache[5] || (_cache[5] = event => _ctx.fileUploaded(event)),
                    accept: "image/png, image/jpeg",
                    ref: "coverPickerRef"
                  }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                  (_ctx.category.icon_b64 && _ctx.category.icon_b64 !== ' ')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("img", {
                            src: _ctx.category.icon_b64,
                            alt: "image"
                          }, null, 8 /* PROPS */, _hoisted_34)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.icon_b64 ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.icon_b64, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createCommentVNode(" <small class=\"text-muted\">*{{ $t('feature.contents.$categories.visibility_checkbox_message') }}</small> ")
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('cta.delete_category')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_42)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ path: '/contents' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_category')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteContentCategory())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteCover())),
      id: `deleteCover`,
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}